import { Button } from 'antd'
import React, { useState } from 'react'
import { CustomLink } from 'src/components'
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import { orderItemLinks } from './order-item.link'
import { BigOrderItem, Order } from 'src/core/models'
import ClaimCertificateModal from './ClaimCertificateModal/ClaimCertificateModal'

interface OrderItemCertificatesProps {
  order: Order
  orderItem: BigOrderItem,
  isPrePurchase?: boolean
}

const OrderItemCertificates: React.FC<OrderItemCertificatesProps> = (props) => {
  const { order, orderItem, isPrePurchase = false } = props
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const links = orderItemLinks(orderItem, order, t)

  return <>
    {links.map((link, idx) => {
      if (!link.show) return
      return (
        <CustomLink
          key={idx}
          label={link.label}
          link={link.link}
          isDisabled={link.isDisabled}
        />
      )
    })}

    {!isPrePurchase && (
      <Button
        type='dashed'
        icon={<SendOutlined />}
        disabled={order.status !== 'paid'}
        onClick={() => setIsModalVisible(true)}
        className='mt-2'
      >
        {t('Transactions.ClaimDocuments')}
      </Button>
    )}

    <ClaimCertificateModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      orderItem={orderItem}
    />
  </>
}

export default OrderItemCertificates
